<template>

  <div class="to_app_container" :style="iosOrAndroidStyle">
<!--    <div class="mobile-page-container" v-if="isShow">-->
<!--      <div class="logo">-->
<!--        <img src="https://files.wondercv.com/m/bbs/welcome-to-app-logo.png" alt="WonderCV">-->
<!--      </div>-->
<!--      <div class="desc">- 超级简历 WonderCV -</div>-->
<!--      <h1 class="content">打开 APP 和 HR 在线直聊</h1>-->
<!--      <div class="example">-->
<!--        <img src="https://files.wondercv.com/m/bbs/welcome-to-app.png" alt="打开APP和HR在线直聊">-->
<!--      </div>-->
<!--      <div class="submit-btn" @click="goToApp">去APP沟通</div>-->
<!--    </div>-->
    <w-nav-bar
      :icon="'iconchevron-left'"
      nav_title=""
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow && !isWxMini"
    />
    <div class="wxmini-container">
      <div class="desc">如需浏览，请长按网址复制后使用浏览器访问</div>
      <div class="hrefs" @touchstart.prevent="onTouchStart" @touchmove.prevent="onTouchMove" @touchend.prevent="onTouchEnd">{{operationData.content}}</div>
    </div>
    <action-sheet-community :action-sheet-state="actionSheetState" :operation="actionSheetOperation"
                            :action-sheet-data="operationData" @selectItem="selectItem"
                            @handleClose="changeActionSheetState"/>
  </div>
</template>

<script>
import {envMixin} from '@/assets/js/mixin/global'
import WNavBar from "@/components/global/w-navbar";
import actionSheetCommunity from '../community/components/action-sheet-community'

export default {
  name: "open_app",
  mixins: [envMixin],
  components: {
    WNavBar,
    actionSheetCommunity
  },
  data() {
    return {
      origin: window.location.origin,
      actionSheetState: false,
      actionSheetOperation: [
        { text: '复制', value: 'copy' }
      ],
      operationData: {content:''},
      timer: null,
      envs: process.env.VUE_APP_ENV,
      type: null
    }
  },
  mounted() {
  },
  beforeDestroy() {
    // this._nullCallBack(null)
  },
  created() {
    this.type = this.$route.query.type
    let phone = this.$route.query.phone
    if (!this.isWxMini) {
      // 判断是否从职位引导页跳转过来   不是的话就加上路由参数    是就不加
      if (this.type) {
        this.operationData.content = `https://m.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/welcome/to_app?type=${ this.type }&phone=${ phone }`
        window.location.href = `https://m.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/welcome/to_app?type=${ this.type }&open=true&phone=${ phone }`
      }else {
        this.operationData.content = `https://m.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/welcome/to_app`
        window.location.href = `https://m.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/welcome/to_app?open=true`
      }
    }else {
      if (this.type) {
        this.operationData.content = `https://m.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/welcome/to_app?type=${ this.type }&phone=${ phone }`
      }else {
        this.operationData.content = `https://m.wondercv.${ process.env.VUE_APP_ENV === 'local' ? 'cn' : 'com' }/welcome/to_app`
      }
    }
  },
  methods: {
    // 开始长按
    onTouchStart () {
      this.timer = setTimeout(() => {
        this.actionSheetState = true
      }, 500)
      return false
    },
    onTouchMove () {
      clearTimeout(this.timer)
      this.timer = null
    },
    onTouchEnd () {
      clearTimeout(this.timer)
      return false
    },

    changeActionSheetState() {
      this.actionSheetState = false
    },
    // 无
    selectItem(obj) {

    },
    // 返回上层
    leftBtnClick() {
      if (this.type) {
        this.$router.push({path: '/welcome/to_app', query: { type: this.type } })
      }else {
        this.$router.push('/welcome/to_app')
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/global/variable";

.to_app_container {
  width: 100vw;
  height: 100vh;
  font-family: PingFangSC-Regular;

  .wxmini-container{
    width: 100vw;
    height: 100vh;
    background-color: #f9f9f9;
    color: #404040;
    overflow: hidden;
    text-align: center;
    font-size: $font-size-medium-x;
    .desc{
      width: 100vw;
      margin-top: 114px;
    }
    .hrefs{
      height: 40px;
      line-height: 40px;
      margin-top: 16px;
    }
  }

  .mobile-page-container {
    margin-top: 0px;
    padding-top: 30px;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-content: flex-start;
    //align-items: flex-start;
    flex-wrap: wrap;

    .logo {
      width: 58px;
      height: 58px;
      margin-top: 28px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .desc {
      width: 100%;
      color: #404040;
      font-size: $font-size-small;
      text-align: center;
      margin-top: 12px;
    }

    .content {
      font-size: $font-size-large;
      margin-top: 8px;
    }

    .example {
      width: 272px;
      height: 244px;
      margin-top: 16px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .submit-btn {
      width: 303px;
      height: 46px;
      margin-top: 36px;
      line-height: 46px;
      text-align: center;
      border-radius: 23px;
      background-color: #ff6644;
      font-size: $font-size-medium-x;
      color: #fff;
    }
  }

} 
</style>